export default __webpack_public_path__ + "static/media/bottom-right.c26f575d.png";